import { render } from "./PromotionPage.vue?vue&type=template&id=4c6e1a94&scoped=true"
import script from "./PromotionPage.vue?vue&type=script&lang=js"
export * from "./PromotionPage.vue?vue&type=script&lang=js"

import "./PromotionPage.vue?vue&type=style&index=0&id=4c6e1a94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6e1a94"]])

export default __exports__